import React from "react";
import {
  ErrorPageWrapper,
  ErrorPageText,
} from "./styles/applicant-review-form-styles";

const ErrorPage = () => (
  <ErrorPageWrapper data-test-id="applicant-review-error-page">
    <span
      role="img"
      aria-label="emoji"
      className="animated fadeInDown delay-1"
      data-test-id="error-page-emoji"
    >
      😮
    </span>
    <ErrorPageText
      className="animated fadeInUp delay-2"
      data-test-id="error-page-text"
    >
      Ooops! Something went wrong.
    </ErrorPageText>
  </ErrorPageWrapper>
);

export default ErrorPage;
